import { gql } from "@apollo/client";

const previewImportOneononeNotesMutation = gql`
  mutation previewImportOneononeNotesMutation(
    $reportUserId: Int!
    $notes: String!
    $timezone: String
  ) {
    previewImportOneononeNotes(
      reportUserId: $reportUserId
      notes: $notes
      timezone: $timezone
    ) {
      plan {
        date
        action
        existingMeeting {
          id
          title
          startDatetime
        }
        topics {
          title
          notes
        }
      }
    }
  }
`;

export default previewImportOneononeNotesMutation;
